import { JsBarcode } from 'jsbarcode'
import * as printConst from '@/api/print/constant.js'

export const getBarcodeBase64 = (barcode, barcodeRule) => {
  /** ******************生成barcode **************/
  //   1.vue中声明
  //   <div id ="barcodeWrapper" type="hidden">
  //      <svg id="barcode"></svg>
  //   </div>
  //   2.content.barcode:barcode值
  //   3.ejs中声明<%-barcode%>
  if (!barcode) {
    return ''
  }
  console.log('barcodeRule:' + JSON.stringify(barcodeRule))
  let barcodeStyle = {}
  if (!barcodeRule) {
    Object.assign(printConst.defaultBarcodeRule, barcodeRule)
  }
  if (typeof (barcodeRule) !== 'undefined') {
    barcodeStyle = barcodeRule
  }
  barcodeStyle.displayValue = true
  console.log(JSON.stringify(barcodeStyle))
  window.JsBarcode('#barcode', barcode, barcodeStyle, printConst.defaultBarcodeRule)
  setImgProp(printConst.defaultBarcodeRule)
  let rawConent = document.getElementById('barcodeWrapper').innerHTML
  // console.log(rawConent.replace(/</g, '').replace(/>/g, '').replace(/"/g, '').split('src=')[1])
  return rawConent.replace(/</g, '').replace(/>/g, '').replace(/"/g, '').split('base64,')[1]
  /** ******************生成barcode **************/
}

export const getCanvasCountryBase64 = (text) => {
  /** ******************生成barcode **************/
  //   1.vue中声明
  //   <canvas ref="canvasCountry" id="canvasCountry" />
  //   2.content.barcode:barcode值
  //   3.ejs中声明<%-barcode%>
  let canvas = document.getElementById('canvasCountry');
  let ctx = canvas.getContext('2d');
  // 头
  ctx.font = "normal 700 40px Arial";
  ctx.fillText("Country", 10, 40);
  // 居中显示 国标
  ctx.textBaseline = 'middle'; //设置文本的垂直对齐方式
  ctx.textAlign = 'center';//设置文本的水平对齐方式
  ctx.fillStyle = '#010101';
  ctx.strokeStyle = 'cornflowerblue';
  ctx.font = "normal 700 80px Arial";
  ctx.fillText(text, canvas.width / 2, canvas.height / 2 + 30);
  //导出
  var base64Img = canvas.toDataURL('image/jpg');
  console.log(base64Img);
  base64Img = base64Img.split("base64,")[1];
  var w = canvas.width;
  var h = canvas.height;
  canvas.width = w;
  canvas.height = h;
  return base64Img
}
/**
 * 设置Img属性（高度和宽度）
 * @param barcodeRule
 */
export const setImgProp = (barcodeRule) => {
  let img_width = barcodeRule.img_width
  let img_height = barcodeRule.img_height
  if (img_width && img_height) {
    let domBarcode = document.getElementById('barcode')
    domBarcode.setAttribute('width', img_width)
    domBarcode.setAttribute('height', img_height)
  }
}
